"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sync = void 0;
const base_1 = require("../base");
exports.Sync = {
    listObjects: (0, base_1.declare)({
        method: 'post',
        path: '/workspaces/:workspaceId/sync/objects/list',
    }).as(),
    createObject: (0, base_1.declare)({
        method: 'post',
        path: '/workspaces/:workspaceId/sync/objects',
    }).as(),
    updateObject: (0, base_1.declare)({
        method: 'patch',
        path: '/workspaces/:workspaceId/sync/objects/:objectId',
    }).as(),
    deleteObject: (0, base_1.declare)({
        method: 'delete',
        path: '/workspaces/:workspaceId/sync/objects/:objectId',
    }).as(),
    createDebugDataUpload: (0, base_1.declare)({
        method: 'post',
        path: '/sync/debugDataUploads',
    }).as(),
    renameDuplicates: (0, base_1.declare)({
        method: 'post',
        path: '/workspaces/:workspaceId/sync/objects/renameDuplicates',
    }).as(),
};
//# sourceMappingURL=Sync.js.map